import { create } from 'zustand';
import { LocationDTO, LocationHierarchyDTO } from '@/shared/api/model';

interface LocationState {
    locations: LocationDTO[];
    selectedLocation: LocationDTO | null;
    locationHierarchy: LocationHierarchyDTO | null;
    isLoading: boolean;
    error: string | null;
    
    // Cascade dropdown state
    zones: LocationDTO[];
    regions: LocationDTO[];
    districts: LocationDTO[];
    wards: LocationDTO[];
    streets: LocationDTO[];
    
    selectedZone: LocationDTO | null;
    selectedRegion: LocationDTO | null;
    selectedDistrict: LocationDTO | null;
    selectedWard: LocationDTO | null;
    selectedStreet: LocationDTO | null;

    // Actions
    setLocations: (locations: LocationDTO[]) => void;
    setSelectedLocation: (location: LocationDTO | null) => void;
    setLocationHierarchy: (hierarchy: LocationHierarchyDTO | null) => void;
    setIsLoading: (isLoading: boolean) => void;
    setError: (error: string | null) => void;
    
    // Cascade actions
    setZones: (zones: LocationDTO[]) => void;
    setRegions: (regions: LocationDTO[]) => void;
    setDistricts: (districts: LocationDTO[]) => void;
    setWards: (wards: LocationDTO[]) => void;
    setStreets: (streets: LocationDTO[]) => void;
    
    setSelectedZone: (zone: LocationDTO | null |undefined) => void;
    setSelectedRegion: (region: LocationDTO | null |undefined) => void;
    setSelectedDistrict: (district: LocationDTO | null |undefined) => void;
    setSelectedWard: (ward: LocationDTO | null |undefined) => void;
    setSelectedStreet: (street: LocationDTO | null |undefined) => void;
    
    resetSelections: () => void;
    resetFromLevel: (level: 'zone' | 'region' | 'district' | 'ward' | 'street') => void;
}

export const useLocationStore = create<LocationState>((set) => ({
    locations: [],
    selectedLocation: null,
    locationHierarchy: null,
    isLoading: false,
    error: null,
    
    zones: [],
    regions: [],
    districts: [],
    wards: [],
    streets: [],
    
    selectedZone: null,
    selectedRegion: null,
    selectedDistrict: null,
    selectedWard: null,
    selectedStreet: null,

    setLocations: (locations) => set({ locations }),
    setSelectedLocation: (selectedLocation) => set({ selectedLocation }),
    setLocationHierarchy: (locationHierarchy) => set({ locationHierarchy }),
    setIsLoading: (isLoading) => set({ isLoading }),
    setError: (error) => set({ error }),
    
    setZones: (zones) => set({ zones }),
    setRegions: (regions) => set({ regions }),
    setDistricts: (districts) => set({ districts }),
    setWards: (wards) => set({ wards }),
    setStreets: (streets) => set({ streets }),
    
    setSelectedZone: (selectedZone) => set({ selectedZone }),
    setSelectedRegion: (selectedRegion) => set({ selectedRegion }),
    setSelectedDistrict: (selectedDistrict) => set({ selectedDistrict }),
    setSelectedWard: (selectedWard) => set({ selectedWard }),
    setSelectedStreet: (selectedStreet) => set({ selectedStreet }),
    
    resetSelections: () => set({
        selectedZone: null,
        selectedRegion: null,
        selectedDistrict: null,
        selectedWard: null,
        selectedStreet: null,
        regions: [],
        districts: [],
        wards: [],
        streets: []
    }),
    
    resetFromLevel: (level) => {
        switch (level) {
            case 'zone':
                set({
                    selectedRegion: null,
                    selectedDistrict: null,
                    selectedWard: null,
                    selectedStreet: null,
                    regions: [],
                    districts: [],
                    wards: [],
                    streets: []
                });
                break;
            case 'region':
                set({
                    selectedDistrict: null,
                    selectedWard: null,
                    selectedStreet: null,
                    districts: [],
                    wards: [],
                    streets: []
                });
                break;
            case 'district':
                set({
                    selectedWard: null,
                    selectedStreet: null,
                    wards: [],
                    streets: []
                });
                break;
            case 'ward':
                set({
                    selectedStreet: null,
                    streets: []
                });
                break;
        }
    }
}));
